/**
 * ORGANIZED VERBIAGE STRUCTURE
 *
 * This file now imports from organized key files:
 * - AltsVerbiage: Alt text keys (moved to 'alts' page)
 * - CommonVerbiage: All other localization keys
 *
 * The original Verbiage enum is maintained for backward compatibility.
 */
// Import organized enums directly from their files
import { AltsVerbiage } from './keys/alts';
import { CommonVerbiage } from './keys/common';
// Export organized enums for developers who want to use them directly
export { AltsVerbiage, CommonVerbiage };
// Export the combined Verbiage for backward compatibility
export const Verbiage = {
    ...AltsVerbiage,
    ...CommonVerbiage
};
